import { Routes } from '@angular/router';
import { userMainRoutes } from './pages/user-main/user-main.routes';

export const routes: Routes = [
  {
    path: 'auth',
    loadComponent: () => import('./pages/auth/auth').then((x) => x.Auth),
  },
  ...userMainRoutes,
  { path: '', redirectTo: 'auth', pathMatch: 'full' },
  {
    path: 'unfinished',
    loadComponent: () =>
      import('./features/unfinished-pages/unfinished-pages').then(
        (x) => x.UnfinishedPages,
      ),
  },
  { path: '**', redirectTo: 'unfinished', pathMatch: 'full' },
];
